import React, { useState } from 'react';
import axios from 'axios';
import { Row, Col, Card, ListGroup, Form, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import Message from '../../../../utilityComponents/Message';
import PropTypes from 'prop-types';


function ScenarioGroupCreation(props) {
    const [ groupName, setGroupName ] = useState('');
    const [ message, setMessage ] = useState('');
    const [ errorMessage, setErrorMessage ] = useState('');

    const handleFormSubmit = (e) => {
        e.preventDefault();
        setMessage('');
        setErrorMessage('');
        const groupNameInput = document.getElementById('bulk-scenario-group-name');
        const selectedScenario = props.info.columns['column-2']['taskIds'];
        const payload = {
            'scenario_group_name': groupName,
            'base_scenarios': selectedScenario.map((id) => {
                const scenarioInfo = props.info.tasks[id];
                return `${scenarioInfo.content}.zip`;
            })
        }
        console.log(payload);
        const url = '/close_loop/create/bulk_scenario_group'
        axios.post(url, payload).then((response) => {
            if(response.status === 200) {
                console.log(response);
                const responseMessage = response.data.message;
                setMessage(responseMessage);
                groupNameInput.value = ''
            }
        }).catch((error) => {
            console.log(error);
            setErrorMessage(error.message);
        })
    }

    return (
        <Card>
            <Card.Header style={{ backgroundColor: '#753DFF' }}>
                <h3 style={{ color: '#FFFFFF' }}>Scenario Group Creation</h3>
            </Card.Header>
            <Card.Body>
                { message && <Message variant='info'>{ message }</Message> }
                { errorMessage && <Message variant='danger'>{ errorMessage }</Message> }
                { props.info.columns['column-2']['taskIds'].length > 0 ? (
                    <Row>
                        <Col xs={4}>
                            <ListGroup>
                                <ListGroup.Item>
                                    <Row>
                                        <Col>
                                            <h3>Selected Scenarios :</h3>
                                            { props.info.columns['column-2']['taskIds'].map((item) => {
                                                const scenarioInfo = Object.values(props.info.tasks).find((subItem) => subItem.id === item);
                                                const info = [];
                                                info.push({'name': scenarioInfo.content, 'variations': scenarioInfo.variation_count});
                                                return (
                                                    info.map((item, index) => (
                                                        <ListGroup key={index}>
                                                            <ListGroup.Item>{ item.name }</ListGroup.Item>
                                                            <ListGroup.Item>Variations : { item.variations }</ListGroup.Item>
                                                        </ListGroup>
                                                    ))
                                                )
                                            }) }
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                            </ListGroup>
                        </Col>
                        <Col xs={4}>
                            <ListGroup>
                                <ListGroup.Item>
                                    <Row>
                                        <Col>
                                            <h3>Custom Maps :</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='text-center'>
                                            <input
                                                id='custom-maps'
                                                type='file'
                                                accept='zip, application/octet-stream, application/zip, application/x-zip, application/x-zip-compressed'
                                            />
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <Row>
                                        <Col>
                                            <h3>AD Client : </h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='text-center'>
                                            <input
                                                id='ad-client'
                                                type='file'
                                                accept='zip, application/octet-stream, application/zip, application/x-zip, application/x-zip-compressed'
                                            />
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                            </ListGroup>
                        </Col>
                        <Col xs={4}>
                            <ListGroup>
                                <Form onSubmit={handleFormSubmit}>
                                    <ListGroup.Item>
                                        <Row>
                                            <Col>
                                                <h3>Scenario Group Name :</h3>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='text-center'>
                                                <input
                                                    id='bulk-scenario-group-name'
                                                    data-testid='bulk-scenario-group-name'
                                                    type='text'
                                                    value={groupName}
                                                    onChange={(e) => { setGroupName(e.target.value) }}
                                                    required
                                                />
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>
                                    <ListGroup.Item>
                                        <Row>
                                            <Col className='text-center'>
                                                <Button
                                                    type='submit'
                                                    data-testid="create-scene-group-btn"
                                                >
                                                    Create Group
                                                </Button>
                                            </Col>
                                        </Row>
                                    </ListGroup.Item>
                                </Form>
                            </ListGroup>
                        </Col>
                    </Row>
                ): (
                    <Message variant='info'>
                        Please Drag & Drop some scenario to Create a Scenario Group
                    </Message>
                )}
            </Card.Body>
        </Card>
    )
}

ScenarioGroupCreation.propTypes={
    info:PropTypes.object
}

const mapStateToProps = (state) => ({
    info: state.bulkScenarioGroup.info
})

export default connect(mapStateToProps, undefined)(ScenarioGroupCreation);